import React from 'react';

export const useAdditionalActions = ({
    fieldsChange,
    price
}: {
    fieldsChange: (name: ('term' | 'propertyCost' | 'ownAmount' | 'purpose' |
        'regionId' | 'propertyType' | 'programCode'), value: (string | number)) => void;
    price: number;
}) => {
    const reset = React.useCallback(() => {
        fieldsChange.bind(null, 'ownAmount')(price * 0.30);
        fieldsChange.bind(null, 'term')(20);
    }, [ fieldsChange, price ]);
    const goBaseProgram = React.useCallback(() => {
        fieldsChange('programCode', 'BASE');
    }, [ fieldsChange ]);

    return {
        reset,
        goBaseProgram
    };
};
